/**
 * Thin GA4 helper. Safely calls `gtag` when the Analytics script has
 * loaded (i.e. REACT_APP_GA_MEASUREMENT_ID is set), otherwise no-op.
 *
 * Standardises the event names so they line up cleanly in GA4's UI and
 * makes it trivial to add funnels / conversions later.
 */

const isEnabled = () =>
  typeof window !== "undefined" &&
  typeof window.gtag === "function" &&
  window.__GA_ID &&
  window.__GA_ID.length > 3;

export function trackEvent(name, params = {}) {
  if (!isEnabled()) return;
  try {
    window.gtag("event", name, params);
  } catch (err) {
    // Analytics failures must never break the app UX. Log for diagnostics only
    // in development — kept silent in production to avoid console noise.
    if (
      typeof process !== "undefined" &&
      process.env &&
      process.env.NODE_ENV !== "production" &&
      typeof console !== "undefined" &&
      console.debug
    ) {
      console.debug("[analytics] trackEvent failed:", name, err);
    }
  }
}

// Dedicated helpers so event names stay consistent everywhere.
export const trackPageView = (path) =>
  trackEvent("page_view", {
    page_location: window.location.href,
    page_path: path || window.location.pathname,
    page_title: document.title,
  });

export const trackLeadSubmitted = (details = {}) =>
  trackEvent("lead_submitted", details);

export const trackWhatsAppClicked = (details = {}) =>
  trackEvent("whatsapp_clicked", details);

export const trackBookAppointmentCompleted = (details = {}) =>
  trackEvent("book_appointment_completed", details);

export const trackPhoneClicked = (details = {}) =>
  trackEvent("phone_clicked", details);

export const trackEnquiryOpened = (details = {}) =>
  trackEvent("enquiry_opened", details);
